import { CheckboxCell } from "@silevis/reactgrid";
import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";
import { SelectCellTemplate } from "pages/BankStatements/BankStatementsGrid/customcells/SelectCellTemplate";

// Master/detail: the checkbox is exclusive — ticking a report selects it (and
// loads its entries), unticking or ticking another report replaces the selection.
class SelectCellTypeHandler implements ICellTypeHandler {
  cellType = "select";
  isCustom = true;
  instance = new SelectCellTemplate();
  determineNewValue = (change: any) => {
    return (change.newCell as CheckboxCell).checked;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    const [, { selectInsurerReport }] = context["insurerReportsStore"];
    const rowId = entry[columnConfig.additionalInfo.rowIdField];

    return {
      type: "select",
      selected: rowsMetadataMap[entry[keyColumn]]?.selected ?? false,
      highlighted: rowsMetadataMap[entry[keyColumn]]?.highlighted ?? false,
      checked: rowsMetadataMap[rowId]?.selected ?? false,
      onChecked: (checked: boolean) => {
        selectInsurerReport(checked ? rowId : null);
      },
    };
  };
}

export default SelectCellTypeHandler;
